<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm2"></a></p><a id="fm2">
<div class="fmhT"><b>GRAILBLAZERS</b></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tomh_9780748113576_oeb_fm2_r1.vue?79977162